import getCookieParam from "../Functions/getCookieParam";

let domain = window.location.href.includes("localhost")
  ? "http://localhost:3001"
  : window.location.origin;
let partners = [];
const setPartners = (list) => {
  partners = list;
};
const DEFAULT_PARTNER_NAME = "engati";
const DEFAULT_PARTNER_ID = "cn5kgIPA";
const getPartnerId = (
  partnerName = getCookieParam("partnerName") || DEFAULT_PARTNER_NAME
) => {
  const partner = partners.find((p) => p.partnerName === partnerName);
  return partner ? partner.partnerId : DEFAULT_PARTNER_ID;
};

const apiComponents = {
  domain: domain,
  otp: domain + "/api/auth/otp/",
  login: domain + "/api/auth/login/",
  customer: domain + "/api/customer/",
  channels: domain + "/api/bsp/channels/",
  apiKey: domain + "/api/bsp/apiKey/",
  pages: domain + "/api/page",
  setPartners,
  get partnerId() {
    return getPartnerId();
  },
};

export default apiComponents;

/*
----- tunnel to backend-app when running frontend on localhost -----
Terminal1: run "ssh -L 3001:localhost:9007 23.22.203.189" > then enter your SSH key password
Terminal2: npm start on port:3000
*/
